import { jsx as _jsx, Fragment as _Fragment } from "preact/jsx-runtime";
import { selectCurrentTask } from "./currentTaskSlice";
import { tasksById } from "./data";
import { useAppSelector } from "./hooks";
export const CurrentTask = () => {
    const taskIdMay = useAppSelector(selectCurrentTask);
    const currentTask = taskIdMay.current ? tasksById[taskIdMay.current] : null;
    return (_jsx(_Fragment, { children: currentTask && (_jsx("div", { class: "card", children: _jsx("h2", { children: currentTask.name }) })) }));
};
